import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './cargo-model';
import { VehiclePart } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import FrontBumperImg from '../../assets/images/cargo-model/front_bumper.png';
import RearBumperImg from '../../assets/images/cargo-model/rear_bumper.png';

interface Props extends VehicleModelProps {
  part: VehiclePart;
}

const BUMPER_IMGS = {
  [VehiclePart.Front]: FrontBumperImg,
  [VehiclePart.Rear]: RearBumperImg,
};

const BUMPER_STYLES = {
  [VehiclePart.Front]: 'width: 8em;',
  [VehiclePart.Rear]: 'width: 10.5em;',
};

class VehicleBumper extends React.Component<Props, any> {
  getVehicleItem = () => `${this.props.part}-bumper`;

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, part, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={BUMPER_IMGS[part]}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleBumper = styled(VehicleBumper)`
  position: relative;
  ${({ part }) => BUMPER_STYLES[part]}
`;

export default StyledVehicleBumper;
